module.exports = __webpack_public_path__ + "img/service.90d6c468.png";